import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const EMAIL_MESSAGE_IMAGE_STATUS_FETCH = createAsyncActionTypes('EMAIL_MESSAGE_IMAGE_STATUS_FETCH');
export const MESSAGE_REFRESH = 'MESSAGE_REFRESH';